"use strict";
var gpsPointSchema = {
    type: 'object',
    // TODO: this schema is used in a few places that need different attributes
    // we need to understand what those are fix this. In the mean time we
    // allow additional properties: (BM 13/02/2019)
    additionalProperties: true,
    required: ['latitude', 'longitude'],
    properties: {
        latitude: {
            type: 'number',
            minimum: -90,
            maximum: 90
        },
        longitude: {
            type: 'number',
            minimum: -180,
            maximum: 180
        },
        height: {
            type: 'number'
        },
        time: {
            type: 'string',
            format: 'date-time'
        }
    }
};
function gpsPointSchemaFunc() {
    var schema = Object.assign({}, gpsPointSchema); // Optionally specify extraRequiredProperties such as 'height' or 'time'
    // E.g. gpsPointSchema('height') requires the 'latitude', 'longitude', and height'
    //      properties, but not 'time'. Whereas gpsPointSchema('height', 'time') requires all of them
    for (var _len = arguments.length, extraRequiredProperties = new Array(_len), _key = 0; _key < _len; _key++) {
        extraRequiredProperties[_key] = arguments[_key];
    }
    schema.required = schema.required.concat(extraRequiredProperties);
    return schema;
}
module.exports = gpsPointSchemaFunc;
